import ExportedImage from 'next-image-export-optimizer';
import sewImage from '../../../../../public/img/product-sew.png';
import stringThreadingImage from '../../../../../public/img/product-string-threading.png';
import tongImage from '../../../../../public/img/product-tong.png';
import { FontSize } from '../../../../constants/FontSize';
import { SectionId } from '../../../../constants/SectionId';
import MainButton from '../../atoms/MainButton';
import SectionTitle from '../../atoms/SectionTitle';
import styles from './index.module.scss';

type Product = {
  price: number;
  name: string;
  imageSrc: string;
  link: string;
};

type ProductImageProps = {
  src: string;
  alt: string;
};

// 外部URL（minne）は next-image-export-optimizer の配信ファイルが生成されず404になるため、そのまま参照する。
// ローカル画像は import 時に StaticImageData（オブジェクト）になるため、文字列のときだけ判定する
const ProductImage = ({ src, alt }: ProductImageProps) => {
  if (typeof src === 'string' && src.startsWith('http')) {
    return <img src={src} className={styles['card-image']} alt={alt} width={100} height={100} loading="lazy" />;
  }
  return <ExportedImage className={styles['card-image']} src={src} alt={alt} width={100} height={100} loading="lazy" />;
};

const products: Product[] = [
  {
    name: '縫いさしスタートセット',
    price: 1980,
    imageSrc: sewImage,
    link: 'https://minne.com/items/36353160',
  },
  {
    name: '紐通しスタートセット',
    price: 1280,
    imageSrc: stringThreadingImage,
    link: 'https://minne.com/items/36459542',
  },
  {
    name: 'あけうつし(トング)スタートセット',
    price: 1480,
    imageSrc: tongImage,
    link: 'https://minne.com/items/36448998',
  },
  {
    name: '紙切り用台紙',
    price: 780,
    imageSrc:
      'https://image.minne.com/minne/mobile_app_product/680x680cq85/8d146eb9ce635e30f25610bf4398c11ea8c4c4e7.jpeg/productimages/177452657/w1600xh1600/715305994ace9095435fde74c371e218ea922ba4.png?1686463374',
    link: 'https://minne.com/items/36479510',
  },
];

const Shop = () => (
  <section id={SectionId.SHOP} className={styles.base}>
    <div className={styles['content-wrapper']}>
      <SectionTitle title="オリジナル教具販売" />
      <p className={styles.description}>
        <span>minneにて実際に教室で使っている教具を中心に販売しています。</span>
        <span>「おうちで気軽にモンテッソーリ」をテーマに、届いたらすぐに使えます。</span>
      </p>
      <div className={styles['shop-cards']}>
        {products.map((product) => (
          <a
            key={product.name}
            href={product.link}
            className={styles['shop-card']}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ProductImage src={product.imageSrc} alt={`${product.name}の画像`} />
            <p className={styles['product-name']}>{product.name}</p>
            <p className={styles.price}>{product.price.toLocaleString()}円</p>
          </a>
        ))}
      </div>

      <a href="https://minne.com/@mirai-monte" target="_blank" rel="noopener noreferrer" aria-label="もっと見る">
        <MainButton isHighlight isHoverEffect buttonText="もっと見る" fontSizeType={FontSize.MEDIUM} />
      </a>
    </div>
  </section>
);

export default Shop;
